import { Box } from '@quintoandar-tokko/jopijs';
import ImageNext from '@/components/shared/ImageNext';
import AlertErrorsIndicator from './AlertErrorsIndicator';
import styles from './portalsNotificationsCard.module.scss';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

function PortalsNotificationsCard({ portal, trackCallback = null }) {
  const tokkoHost = localStorage.getItem('tokkoBrokerHost');
  const { name, alerts, errors, portal_id } = portal;

  const openPortal = () => {
    window.open(`${tokkoHost}/portals/publications/${portal_id}`, '_blank');

    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.PORTAL_NAME);
    }
  };
  return (
    <Box className={styles.portalsNotificationsCard} onClick={openPortal}>
      <Box className={styles.portalCardContainer}>
        <ImageNext src={portal.icon} width={107} height={33} alt={name} />
      </Box>
      <AlertErrorsIndicator
        portalId={portal_id}
        alerts={alerts}
        errors={errors}
      />
    </Box>
  );
}

export default PortalsNotificationsCard;
